import { useEffect, useMemo, useState } from "react";
import { Daniblifting1280, Daniblifting1366, Daniblifting1920, DanibliftingMob, DanibliftingTablet, JSterling1280, JSterling1366, JSterling1920, JSterlingMob, JSterlingTablet, MHST1280, MHST1366, MHST1920, MHSTMob, MHSTTablet, Pedim1280, Pedim1366, Pedim1920, PedimMob, PedimTablet, QCM1280, QCM1366, QCM1920, QCMMob, QCMTablet, Scofa1280, Scofa1366, Scofa1920, ScofaMob, ScofaMotherDay1280, ScofaMotherDay1366, ScofaMotherDay1920, ScofaMotherDayMob, ScofaMotherDayTablet, ScofaRSC1280, ScofaRSC1366, ScofaRSC1920, ScofaRSCMob, ScofaRSCTablet, ScofaTablet, SleepCare1280, SleepCare1366, SleepCare1920, SleepCareMob, SleepCareTablet } from "../../Assets/images";
import Promo from "./Promo";
import CorporatePromo from "./CorporatePromo";
import MothersDay from "./MothersDay";
import Common from "../../Util/common";
import "./style.css";
import { useTranslation } from "react-i18next";

const PromoPush = ({ handleContinueButton }) => {

    const [openedPageData, setOpenedPageData] = useState({});
    const [isCorporatePage, setIsCorporatePage] = useState(false);
    const [loading, setLoading] = useState(true); // New loading state
    const { t } = useTranslation();
    const data = useMemo(() => buildPromoData(t), [t]);

    useEffect(() => {
        const path = window.location.pathname?.toLowerCase().split("/")[1];
        const routes = Common.LANDING_PAGES;
        if (window.location.pathname?.toLowerCase().split("/")[2] === "celebratemom2025") {
            document.querySelector("body")?.classList?.add("overflow-hidden");
            setOpenedPageData(data['celebratemom2025'] || {});
            setIsCorporatePage(true);
        } else if (path != "promoint" && path != "promo" && routes.includes(path)) {
            document.querySelector("body")?.classList?.add("overflow-hidden");
            setOpenedPageData(data[path] || {});
            setIsCorporatePage(true);
        } else {
            setOpenedPageData({});
            setIsCorporatePage(false);
        }
        setLoading(false); // Mark as loaded after checking conditions
    }, [data])

    if (loading) return null; // Prevent rendering until useEffect is executed

    return (
        <>
            {
                isCorporatePage ? (
                    window.location.pathname?.toLowerCase().includes('celebratemom2025') ? (
                        <MothersDay data={openedPageData} handleContinue={() => handleContinueButton()} />
                    ) : (
                        <CorporatePromo data={openedPageData} handleContinue={() => handleContinueButton()} />
                    )
                ) : (
                    <Promo data={openedPageData} handleContinue={() => handleContinueButton()} />
                )
            }
        </>
    );
};

export default PromoPush;


const buildPromoData = (t) => ({
    "pedim": {
        "text1": t("promo.pedim.text1"),
        "text2": t("promo.pedim.text2"),
        "text3": t("promo.pedim.text3"),
        "text4": t("promo.pedim.text4"),
        "text5": t("promo.pedim.text5"),
        "text6": t("promo.pedim.text6"),
        "text7": t("promo.pedim.text7"),
        "list": t("promo.pedim.list", { returnObjects: true }) || [],
        "img_1920": Pedim1920,
        "img_1366": Pedim1366,
        "img_1280": Pedim1280,
        "img_tablet": PedimTablet,
        "img_mob": PedimMob,
        "bg": Pedim1920,
        "page_name": Common.PEDIM,
        "alignment_out": true
    },
    "pedim-ext": {
        "text1": t("promo.pedimExt.text1"),
        "text2": t("promo.pedimExt.text2"),
        "text3": t("promo.pedimExt.text3"),
        "text4": t("promo.pedimExt.text4"),
        "text5": t("promo.pedimExt.text5"),
        "text6": t("promo.pedimExt.text6"),
        "text7": t("promo.pedimExt.text7"),
        "list": t("promo.pedimExt.list", { returnObjects: true }) || [],
        "list_by_company": t("promo.pedimExt.listByCompany", { returnObjects: true }) || [],
        "img_1920": Pedim1920,
        "img_1366": Pedim1366,
        "img_1280": Pedim1280,
        "img_tablet": PedimTablet,
        "img_mob": PedimMob,
        "bg": Pedim1920,
        "page_name": Common.PEDIM,
        "alignment_out": true
    },
    "qcm": {
        "text1": t("promo.qcm.text1"),
        "text2": t("promo.qcm.text2"),
        "text3": t("promo.qcm.text3"),
        "text4": t("promo.qcm.text4"),
        "text5": t("promo.qcm.text5"),
        "text6": t("promo.qcm.text6"),
        "text7": t("promo.qcm.text7"),
        "list": t("promo.qcm.list", { returnObjects: true }) || [],
        "img_1920": QCM1920,
        "img_1366": QCM1366,
        "img_1280": QCM1280,
        "img_tablet": QCMTablet,
        "img_mob": QCMMob,
        "bg": QCM1920,
        "page_name": Common.QCM,
        "alignment_out": true
    },
    "qcm-ext": {
        "text1": t("promo.qcmExt.text1"),
        "text2": t("promo.qcmExt.text2"),
        "text3": t("promo.qcmExt.text3"),
        "text4": t("promo.qcmExt.text4"),
        "text5": t("promo.qcmExt.text5"),
        "text6": t("promo.qcmExt.text6"),
        "text7": t("promo.qcmExt.text7"),
        "list": t("promo.qcmExt.list", { returnObjects: true }) || [],
        "list_by_company": t("promo.qcmExt.listByCompany", { returnObjects: true }) || [],
        "img_1920": QCM1920,
        "img_1366": QCM1366,
        "img_1280": QCM1280,
        "img_tablet": QCMTablet,
        "img_mob": QCMMob,
        "bg": QCM1920,
        "page_name": Common.QCM,
        "alignment_out": true
    },
    "daniblifting": {
        "text1": t("promo.daniblifting.text1"),
        "text2": t("promo.daniblifting.text2"),
        "text3": t("promo.daniblifting.text3"),
        "text4": t("promo.daniblifting.text4"),
        "text5": t("promo.daniblifting.text5"),
        "text6": t("promo.daniblifting.text6"),
        "text7": t("promo.daniblifting.text7"),
        "list": t("promo.daniblifting.list", { returnObjects: true }) || [],
        "img_1920": Daniblifting1920,
        "img_1366": Daniblifting1366,
        "img_1280": Daniblifting1280,
        "img_tablet": DanibliftingTablet,
        "img_mob": DanibliftingMob,
        "bg": Daniblifting1920,
        "page_name": Common.DANIBLIFTING,
        "alignment_out": false
    },
    "jsterling": {
        "text1": t("promo.jsterling.text1"),
        "text2": t("promo.jsterling.text2"),
        "text3": t("promo.jsterling.text3"),
        "text4": t("promo.jsterling.text4"),
        "text5": t("promo.jsterling.text5"),
        "text6": t("promo.jsterling.text6"),
        "text7": t("promo.jsterling.text7"),
        "list": t("promo.jsterling.list", { returnObjects: true }) || [],
        "img_1920": JSterling1920,
        "img_1366": JSterling1366,
        "img_1280": JSterling1280,
        "img_tablet": JSterlingTablet,
        "img_mob": JSterlingMob,
        "bg": JSterling1920,
        "page_name": Common.JSTERLING
    },
    "mhst": {
        "text1": t("promo.mhst.text1"),
        "text2": t("promo.mhst.text2"),
        "text3": t("promo.mhst.text3"),
        "text4": t("promo.mhst.text4"),
        "text5": t("promo.mhst.text5"),
        "text6": t("promo.mhst.text6"),
        "text7": t("promo.mhst.text7"),
        "list": t("promo.mhst.list", { returnObjects: true }) || [],
        "img_1920": MHST1920,
        "img_1366": MHST1366,
        "img_1280": MHST1280,
        "img_tablet": MHSTTablet,
        "img_mob": MHSTMob,
        "mobile_img": MHSTMob,
        "bg": MHST1920,
        "page_name": Common.MHST
    },
    "mhst6": {
        "text1": t("promo.mhst6.text1"),
        "text2": t("promo.mhst6.text2"),
        "text3": t("promo.mhst6.text3"),
        "text4": t("promo.mhst6.text4"),
        "text5": t("promo.mhst6.text5"),
        "text6": t("promo.mhst6.text6"),
        "text7": t("promo.mhst6.text7"),
        "list": t("promo.mhst6.list", { returnObjects: true }) || [],
        "img_1920": MHST1920,
        "img_1366": MHST1366,
        "img_1280": MHST1280,
        "img_tablet": MHSTTablet,
        "img_mob": MHSTMob,
        "mobile_img": MHSTMob,
        "bg": MHST1920,
        "logo": MHST1920,
        "page_name": Common.MHST,
        "is_new": false
    },
    "sleep-care": {
        "text1": t("promo.sleepCare.text1"),
        "text2": t("promo.sleepCare.text2"),
        "text3": t("promo.sleepCare.text3"),
        "text4": t("promo.sleepCare.text4"),
        "text5": t("promo.sleepCare.text5"),
        "text6": t("promo.sleepCare.text6"),
        "text7": t("promo.sleepCare.text7"),
        "list": t("promo.sleepCare.list", { returnObjects: true }) || [],
        "img_1920": SleepCare1920,
        "img_1366": SleepCare1366,
        "img_1280": SleepCare1280,
        "img_tablet": SleepCareTablet,
        "img_mob": SleepCareMob,
        "mobile_img": SleepCareMob,
        "bg": SleepCare1920,
        "page_name": Common.SLEEPCARE
    },
    "free6": {
        "text1": t("promo.free6.text1"),
        "text2": t("promo.free6.text2"),
        "text3": t("promo.free6.text3"),
        "text4": t("promo.free6.text4"),
        "text5": t("promo.free6.text5"),
        "text6": t("promo.free6.text6"),
        "text7": t("promo.free6.text7"),
        "list": t("promo.free6.list", { returnObjects: true }) || [],
        "img_1920": Scofa1920,
        "img_1366": Scofa1366,
        "img_1280": Scofa1280,
        "img_tablet": ScofaTablet,
        "img_mob": ScofaMob,
        "mobile_img": ScofaMob,
        "bg": Scofa1920,
        "logo": Scofa1920,
        "page_name": Common.QCM,
        "is_new": false
    },
    "scofa-1gdxmk": {
        "text1": t("promo.scofa1.text1"),
        "text2": t("promo.scofa1.text2"),
        "text3": t("promo.scofa1.text3"),
        "text4": t("promo.scofa1.text4"),
        "text5": t("promo.scofa1.text5"),
        "text6": t("promo.scofa1.text6"),
        "text7": t("promo.scofa1.text7"),
        "text8": t("promo.scofa1.text8"),
        "list": t("promo.scofa1.list", { returnObjects: true }) || [],
        "list_by_company": t("promo.scofa1.listByCompany", { returnObjects: true }) || [],
        "img_1920": ScofaRSC1920,
        "img_1366": ScofaRSC1366,
        "img_1280": ScofaRSC1280,
        "img_tablet": ScofaRSCTablet,
        "img_mob": ScofaRSCMob,
        "bg": ScofaRSC1920,
        "page_name": Common.PEDIM,
        "alignment_out": true
    },
    "scofa-3m8qmx": {
        "text1": t("promo.scofa3.text1"),
        "text2": t("promo.scofa3.text2"),
        "text3": t("promo.scofa3.text3"),
        "text4": t("promo.scofa3.text4"),
        "text5": t("promo.scofa3.text5"),
        "text6": t("promo.scofa3.text6"),
        "text7": t("promo.scofa3.text7"),
        "text8": t("promo.scofa3.text8"),
        "list": t("promo.scofa3.list", { returnObjects: true }) || [],
        "list_by_company": t("promo.scofa3.listByCompany", { returnObjects: true }) || [],
        "img_1920": ScofaRSC1920,
        "img_1366": ScofaRSC1366,
        "img_1280": ScofaRSC1280,
        "img_tablet": ScofaRSCTablet,
        "img_mob": ScofaRSCMob,
        "bg": ScofaRSC1920,
        "page_name": Common.PEDIM,
        "alignment_out": true
    },
    "scofa-6kdxmv": {
        "text1": t("promo.scofa6.text1"),
        "text2": t("promo.scofa6.text2"),
        "text3": t("promo.scofa6.text3"),
        "text4": t("promo.scofa6.text4"),
        "text5": t("promo.scofa6.text5"),
        "text6": t("promo.scofa6.text6"),
        "text7": t("promo.scofa6.text7"),
        "text8": t("promo.scofa6.text8"),
        "list": t("promo.scofa6.list", { returnObjects: true }) || [],
        "list_by_company": t("promo.scofa6.listByCompany", { returnObjects: true }) || [],
        "img_1920": ScofaRSC1920,
        "img_1366": ScofaRSC1366,
        "img_1280": ScofaRSC1280,
        "img_tablet": ScofaRSCTablet,
        "img_mob": ScofaRSCMob,
        "bg": ScofaRSC1920,
        "page_name": Common.PEDIM,
        "alignment_out": true
    },
    "scofa-50qypz": {
        "text1": t("promo.scofa50.text1"),
        "text2": t("promo.scofa50.text2"),
        "text3": t("promo.scofa50.text3"),
        "text4": t("promo.scofa50.text4"),
        "text5": t("promo.scofa50.text5"),
        "text6": t("promo.scofa50.text6"),
        "text7": t("promo.scofa50.text7"),
        "text8": t("promo.scofa50.text8"),
        "list": t("promo.scofa50.list", { returnObjects: true }) || [],
        "list_by_company": t("promo.scofa50.listByCompany", { returnObjects: true }) || [],
        "img_1920": ScofaRSC1920,
        "img_1366": ScofaRSC1366,
        "img_1280": ScofaRSC1280,
        "img_tablet": ScofaRSCTablet,
        "img_mob": ScofaRSCMob,
        "bg": ScofaRSC1920,
        "page_name": Common.PEDIM,
        "alignment_out": true
    },
    "celebratemom2025": {
        "text1": t("promo.celebrateMom.text1"),
        "text2": t("promo.celebrateMom.text2"),
        "text3": t("promo.celebrateMom.text3"),
        "text4": t("promo.celebrateMom.text4"),
        "text5": t("promo.celebrateMom.text5"),
        "text6": t("promo.celebrateMom.text6"),
        "text7": t("promo.celebrateMom.text7"),
        "text8": t("promo.celebrateMom.text8"),
        "list": t("promo.celebrateMom.list", { returnObjects: true }) || [],
        "list_by_company": t("promo.celebrateMom.listByCompany", { returnObjects: true }) || [],
        "img_1920": ScofaMotherDay1920,
        "img_1366": ScofaMotherDay1366,
        "img_1280": ScofaMotherDay1280,
        "img_tablet": ScofaMotherDayTablet,
        "img_mob": ScofaMotherDayMob,
        "bg": ScofaMotherDay1920,
        "page_name": Common.PEDIM,
        "class": "happy-mothers-day",
        "alignment_out": true
    },
});